import _ from 'lodash';

import {
  NATIONALITY_INFO,
  BLOOD_TYPE,
  BLOOD_TYPE_RH,
  EXISTANCE_FLAG,
  EXISTANCE_EXCLUSION_FLAG,
  ASSIGNED_DUE_TO_ILLNESS_FLAG,
  OBSERVATION_EXISTANCE_FLAG,
  INSURANCE_RECEIVING_FLAG,
  WORKER_COMPENSATION_TYPE,
  MANUAL_CONTACT_TAB,
  WORKER_TAB,
  LEGAL_PERSONALITIES,
  PREFECTURE_GROUPS,
  AGENCY_REGISTRATION_APPLICATION_STATUS,
  PENSION_VOLUNTARY_COVERAGE_FLAG,
} from './constants';

/**
 * 定数オブジェクトから指定要素を取り出す関数
 * 使い方例
 *  const getTextBloodTypeId = id => {
 *    return getValueConstant(BLOOD_TYPE, 'ID', id, 'TEXT');
 *  };
 *    これで、id に '2' を指定すると 'B' が返る
 *    一致するものがみつからなければ undefined を返す
 */
export const getValueConstant = (
  constantObject,
  searchKey,
  value,
  outputKey
) => {
  const result = Object.keys(constantObject).find(key => {
    return constantObject[key][searchKey] === value;
  });
  if (_.isUndefined(result)) {
    return;
  }
  return constantObject[result][outputKey];
};

// 国籍
export const getTextNationalityInfoId = id => {
  return getValueConstant(NATIONALITY_INFO, 'ID', id, 'TEXT');
};

// 血液型 A B O AB
export const getTextBloodTypeId = id => {
  return getValueConstant(BLOOD_TYPE, 'ID', id, 'TEXT');
};

// 血液型 RH + -
export const getTextBloodTypeRhId = value => {
  return getValueConstant(BLOOD_TYPE_RH, 'ID', value, 'TEXT');
};

// 有無
export const getTextExistanceFlag = id => {
  return getValueConstant(EXISTANCE_FLAG, 'ID', id, 'TEXT');
};
export const getTextExistanceFlagValue = value => {
  return getValueConstant(EXISTANCE_FLAG, 'VALUE', value, 'TEXT');
};

// 有無適用除外
export const getTextExistanceExclusionFlag = id => {
  return getValueConstant(EXISTANCE_EXCLUSION_FLAG, 'ID', id, 'TEXT');
};

// 所見の有無
export const getTextObservationExistanceExclusionFlag = id => {
  return getValueConstant(OBSERVATION_EXISTANCE_FLAG, 'ID', id, 'TEXT');
};

// 疾病による適正配置対象者フラグ
export const getTextAssignedDueToIllnessFlag = id => {
  return getValueConstant(ASSIGNED_DUE_TO_ILLNESS_FLAG, 'ID', id, 'TEXT');
};

// 受給状況(年金)
export const getTextInsuranceReceivingFlag = id => {
  return getValueConstant(INSURANCE_RECEIVING_FLAG, 'ID', id, 'TEXT');
};

// 任意加入(年金)
export const getTextPensionVoluntaryCoverageFlag = id => {
  return getValueConstant(PENSION_VOLUNTARY_COVERAGE_FLAG, 'ID', id, 'TEXT');
};

// 労災保険種類
export const getTextWorkerCompensationType = id => {
  return getValueConstant(WORKER_COMPENSATION_TYPE, 'ID', id, 'TEXT');
};

// マニュアル・問い合わせ画面タブ
export const getNameManualContact = id => {
  return getValueConstant(MANUAL_CONTACT_TAB, 'ID', id, 'NAME');
};

// 作業員タブ
export const getTabNameWorkerTabId = id => {
  return getValueConstant(WORKER_TAB, 'ID', id, 'TAB_NAME');
};
export const getIdWorkerTabTabName = tabName => {
  return getValueConstant(WORKER_TAB, 'TAB_NAME', tabName, 'ID');
};

export const getLegalPersonalitiesById = id => {
  const item = _.filter(_.map(LEGAL_PERSONALITIES), x => x.id === id);
  return item.length ? item[0].name : null;
};

export const getPrefectureGroupById = id => {
  const item = _.filter(
    _.flatten(_.map(PREFECTURE_GROUPS, x => _.values(x.prefectures))),
    x => x.id === id
  );
  return item.length ? item[0].name : null;
};

export const getAgencyRegistrationApplicationStatus = id => {
  return getValueConstant(
    AGENCY_REGISTRATION_APPLICATION_STATUS,
    'ID',
    id,
    'TEXT'
  );
};



// WEBPACK FOOTER //
// ./src/utilities/constantsUtil.js